module.exports = __webpack_public_path__ + "static/media/cleaning.734de0d0.svg";